module.exports = __webpack_public_path__ + "static/media/sneakpeak-01-old.4d3ab48b.jpg";